export const getFiveDaysFromNowDate = () => {
  const today = new Date()
  const finalDate = new Date(today)
  finalDate.setDate(today.getDate() + 5)

  return finalDate
}
